import styled from 'styled-components';

export const $Container = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.systemColors.secondaryBackground};
`;
